/**
 * Objeto representando um item do relatório de clientes
 */
class ClientesItem {

    /**
     * Cria uma nova instância do objeto
     * @param {String} rotulo Rótulo do item do relatório
     * @param {Number} quantidade Quantidade de clientes
     */
    constructor (rotulo, quantidade) {
        /** @member {String} rotulo Rótulo do item do relatório */
        this.rotulo = rotulo;
        /** @member {Number} quantidade Quantidade de clientes */
        this.quantidade = quantidade;
    }

    /**
     * Cria uma cópia do objeto
     * @param {ClientesItem} origem Objeto a ser clonado
     * @return {ClientesItem} Cópia do objeto original
     */
    static clone(origem) {
        return new ClientesItem(origem.rotulo, origem.quantidade);
    }
}

/**
 * Objeto representando os relatórios de clientes
 */
class Clientes {
    /**
     * Cria uma nova instância do objeto
     * @param {Array<ClientesItem>} patologia Relatório de clientes por patologia
     * @param {Array<ClientesItem>} genero Relatório de clientes por gênero
     * @param {Array<ClientesItem>} idade Relatório de clientes por idade
     * @param {Array<ClientesItem>} profissao Relatório de clientes por profissão
     * @param {Array<ClientesItem>} bairro Relatório de clientes por bairro
     */
    constructor(patologia, genero, idade, profissao, bairro) {
        /** @member {Array<ClientesItem>} patologia Relatório de clientes por patologia */
        this.patologia = patologia ?? [ ];
        /** @member {Array<ClientesItem>} genero Relatório de clientes por gênero */
        this.genero = genero ?? [ ];
        /** @member {Array<ClientesItem>} idade Relatório de clientes por idade */
        this.idade = idade ?? [ ];
        /** @member {Array<ClientesItem>} profissao Relatório de clientes por profissão */
        this.profissao = profissao ?? [ ];
        /** @member {Array<ClientesItem>} bairro Relatório de clientes por bairro */
        this.bairro = bairro ?? [ ];
    }

    /**
     * Cria uma cópia do objeto
     * @param {Clientes} origem Objeto a ser clonado
     * @returns {Clientes} Cópia do objeto original
     */
    static clone(origem) {
        let patologia = [];
        if (origem.patologia)
            patologia = origem.patologia.map(item => ClientesItem.clone(item));

        let genero = [];
        if (origem.genero)
            genero = origem.genero.map(item => ClientesItem.clone(item));

        let idade = [];
        if (origem.idade)
            idade = origem.idade.map(item => ClientesItem.clone(item));

        let profissao = [];
        if (origem.profissao)
            profissao = origem.profissao.map(item => ClientesItem.clone(item));

        let bairro = [];
        if (origem.bairro)
            bairro = origem.bairro.map(item => ClientesItem.clone(item));
        
        return new Clientes(patologia, genero, idade, profissao, bairro);
    }
}

export default Clientes;